import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import styles from './DownloadButton.module.less';
import {
  getIsVideoUploadingToBucket,
  getCampaignBanner,
  getUseCampaignBanner
} from '../../redux/modules/campaignLandingPage';
import { StyledOutlineBrandingButton } from './styles';

const DownloadButton = ({ mediaBlobUrl, qid, isVideoUploading, backgroundColor, useBanner }) => {
  if (!mediaBlobUrl) {
    return null;
  }

  const useCustomStyle = useBanner && backgroundColor;

  return (
    <StyledOutlineBrandingButton
      component="a"
      id={`vpDownloadVideoButton-${qid}`}
      href={`${isVideoUploading ? '#' : mediaBlobUrl}`}
      download="recorded-video.mp4"
      variant="outlined"
      disabled={isVideoUploading}
      backgroundColor={backgroundColor}
      custom={useCustomStyle}
      sx={{ gap: '5px', width: '100%' }}
    >
      <Icon className={styles.vpDownloadIcon} icon="download2" />
      Download Video
    </StyledOutlineBrandingButton>
  );
};

DownloadButton.propTypes = {
  mediaBlobUrl: PropTypes.string,
  qid: PropTypes.string,
  isVideoUploading: PropTypes.bool,
  backgroundColor: PropTypes.string,
  useBanner: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
  isVideoUploading: getIsVideoUploadingToBucket(state, ownProps.qid),
  backgroundColor: getCampaignBanner(state),
  useBanner: getUseCampaignBanner(state)
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/DownloadButton.jsx